'use client'

import { type PropsWithChildren } from 'react'

import type { PortalOnboardingDomTargetId } from '@apps/portal-onboarding/portal-onboarding.const'
import { PORTAL_ONBOARDING_TARGET_TEST_IDS } from '@apps/portal-onboarding/portal-onboarding-test-ids.const'

type PortalOnboardingTargetProps = PropsWithChildren<{
  id: PortalOnboardingDomTargetId
  className?: string
}>

export function PortalOnboardingTarget({ id, className, children }: PortalOnboardingTargetProps) {
  return (
    <div
      className={className}
      data-portal-onboarding={id}
      data-testid={PORTAL_ONBOARDING_TARGET_TEST_IDS.root}
      style={{ display: 'contents' }}
    >
      {children}
    </div>
  )
}

export { PORTAL_ONBOARDING_DOM_TARGET } from '@apps/portal-onboarding/portal-onboarding.const'
